import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LocationUpgradeModule } from '@angular/common/upgrade';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { UpgradeModule, setAngularJSGlobal } from '@angular/upgrade/static';
import * as angular from 'angular';
import { provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { CoreModule } from '@app/core';
import { HttpErrorInterceptor, SchoolLinqApiInterceptor } from '@app/core/interceptors';
import { HttpErrorService } from '@app/core/services';
import { DashboardModule } from '@app/modules';
import { AppRoutingModule } from '@app/modules/app-routing.module';
import { SharedModule } from '@app/shared';
import { AJS_INTIALIZER, AUTH_INITIALIZER, DECORATORS_INITIALIZER, SOCKETS_INITIALIZER } from './app/app.initializer';
import { authConfig } from './app/auth/auth.config';
import { DowngradeModule } from './app/downgrade.module';
import { AppComponent } from './app/shared/layout/app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

setAngularJSGlobal(angular);

const bootstrap = () =>
	bootstrapApplication(AppComponent, {
		providers: [
			importProvidersFrom(
				BrowserModule,
				CoreModule,
				SharedModule,
				AppRoutingModule,
				DashboardModule,
				UpgradeModule,
				DowngradeModule,
				LocationUpgradeModule.config({
					useHash: false,
				}),
			),
			AJS_INTIALIZER,
			AUTH_INITIALIZER,
			SOCKETS_INITIALIZER,
			DECORATORS_INITIALIZER,
			{
				provide: HTTP_INTERCEPTORS,
				useClass: SchoolLinqApiInterceptor,
				multi: true,
			},
			{
				provide: HTTP_INTERCEPTORS,
				useClass: HttpErrorInterceptor,
				multi: true,
			},
			HttpErrorService,
			provideAnimations(),
			provideHttpClient(withInterceptorsFromDi()),
			provideAuth(authConfig, withAppInitializerAuthCheck()),
		],
	});

bootstrap();
